import { DEFAULT_MAP_STYLE } from "../constants";
import { MapStyle } from "../enums/map-style.enum";

export function toValidMapStyle(stored: string | null | undefined): MapStyle {
  if (stored && Object.values(MapStyle).includes(stored as MapStyle)) {
    return stored as MapStyle;
  }

  return DEFAULT_MAP_STYLE;
}
